import { render, staticRenderFns } from "./VideoLibHeader.vue?vue&type=template&id=4f471891"
import script from "./VideoLibHeader.vue?vue&type=script&lang=js"
export * from "./VideoLibHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports